import BoldIcon from "@redotech/redo-icons/bold-01.svg";
import ItalicIcon from "@redotech/redo-icons/italic-01_filled.svg";
import StrikethroughIcon from "@redotech/redo-icons/strikethrough-01_filled.svg";
import UnderlineIcon from "@redotech/redo-icons/underline-01_filled.svg";
import ZapIcon from "@redotech/redo-icons/zap.svg";
import { useMetaKey } from "@redotech/redo-web/command-palette/hooks/use-meta-key";
import { EmojiToolbarButton } from "@redotech/redo-web/components/plate-ui/emoji-toolbar-button";
import { LinkToolbarButton } from "@redotech/redo-web/components/plate-ui/link-toolbar-button";
import { MarkToolbarButton } from "@redotech/redo-web/components/plate-ui/mark-toolbar-button";
import {
  FileToolbarButton,
  ImageToolbarButton,
} from "@redotech/redo-web/components/plate-ui/media-toolbar-buttons";
import {
  ToolbarButton,
  ToolbarGroup,
} from "@redotech/redo-web/components/plate-ui/toolbar";
import { ToolbarWithOverflow } from "@redotech/redo-web/components/plate-ui/toolbar-overflow";
import { cn } from "@redotech/redo-web/tailwind-utils";
import { KEYS } from "platejs";
import { memo } from "react";
import { AiMenuToolbarButton } from "./ai-menu-toolbar-button";

export interface ChatToolbarProps {
  className?: string;
  isGeneratingAiResponse?: boolean;
  isPolishingMessage?: boolean;
  onFileSelect?: (files: File[]) => void;
  onGenerateAiResponse?: () => void;
  onImageSelect?: (file: File) => void;
  onMacroClick?: () => void;
  onPolishMessage?: () => void;
}

export const ChatToolbar = memo(function ChatToolbar({
  className,
  isGeneratingAiResponse,
  isPolishingMessage,
  onFileSelect,
  onGenerateAiResponse,
  onImageSelect,
  onMacroClick,
  onPolishMessage,
}: ChatToolbarProps) {
  const metaKey = useMetaKey();

  return (
    <ToolbarWithOverflow className={cn("border-border px-1 py-1", className)}>
      <ToolbarGroup>
        <AiMenuToolbarButton
          isGeneratingAiResponse={isGeneratingAiResponse}
          isPolishingMessage={isPolishingMessage}
          onGenerateAiResponse={onGenerateAiResponse}
          onPolishMessage={onPolishMessage}
        />
        <ToolbarButton
          Icon={() => <ZapIcon />}
          onClick={onMacroClick}
          tooltip="Macros"
        />
      </ToolbarGroup>

      <ToolbarGroup>
        <MarkToolbarButton
          Icon={BoldIcon}
          nodeType={KEYS.bold}
          tooltip={`Bold (${metaKey}+B)`}
        />
        <MarkToolbarButton
          Icon={ItalicIcon}
          nodeType={KEYS.italic}
          tooltip={`Italic (${metaKey}+I)`}
        />
        <MarkToolbarButton
          Icon={UnderlineIcon}
          nodeType={KEYS.underline}
          tooltip={`Underline (${metaKey}+U)`}
        />
        <MarkToolbarButton
          Icon={StrikethroughIcon}
          nodeType={KEYS.strikethrough}
          tooltip="Strikethrough"
        />
      </ToolbarGroup>

      <LinkToolbarButton />
      <EmojiToolbarButton />
      <ImageToolbarButton onImageSelect={onImageSelect} />
      <FileToolbarButton onFileSelect={onFileSelect} />
    </ToolbarWithOverflow>
  );
});
